<template>
  <el-table-column
    prop="created_at"
    sortable="custom"
    label="Létrehozva"
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.created_at | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'created_at',
};
</script>
